import { createApp } from 'vue';
import App from '@/pages/main-saas/App.vue';
import pinia from '@/store';
import { useAccount } from '@/store/account';
import storesAppConfig from '@/store/appConfig';
import conf from '@/conf/config.json';
import { Session } from '@/utils/storage';

//设置App配置的code
storesAppConfig.setCode(conf.apps.main_saas);

const app = createApp(App);
app.use(pinia);

const token = Session.get('token');
if (!token) {
	Session.clear();
	window.location.href = 'login.html';
} else {
	useAccount()
		.getPermiss()
		.then(() => {
			window.location.href = conf.pages[useAccount().appId];
		});
}
